@for (option of multicheckboxOptions; track option; let i = $index) {
  <div class="form-check">
    <input class="form-check-input" type="checkbox"
      autocomplete="off"
      [id]="id + '_' + i"
      [value]="option.value"
      [checked]="formControl.value && (this.props.type === 'array' ? formControl.value.includes(option.value) : formControl.value[option.value])"
      [formlyAttributes]="field"
      (change)="onChange(option.value, $event.target)">
    <label class="form-check-label" [for]="id + '_' + i">
      {{ option.label }}
    </label>
  </div>
}
